import React from 'react';
import Helmet from 'react-helmet';
import * as styles from './form-404.module.styl';
import DefaultLayout from '../layouts';
import isForm404 from '../utils/isForm404';

export default class Form404 extends React.Component {
  componentDidMount() {
    if (isForm404(this.props.location)) {
      this._404 = true;
      this.forceUpdate();
    }
  }

  render() {
    const props = this.props;
    if (!this._404 && props.children) {
      return props.children;
    }
    return (
      <DefaultLayout {...props} noNav noFooter>
        <Helmet>
          <title>Paperform: Online Form Builder And Form Creator</title>
          <link rel="canonical" href="https://paperform.co/" />
        </Helmet>
        <div className={styles.wrapper}>
          <a
            target="_blank"
            style={{ textDecoration: 'none !important' }}
            href="https://paperform.co?utm_source=expiredform&utm_campaign=expiredform"
            rel="noreferrer"
          >
            <img
              src="https://paperform.co/images/logo-v3/Paperform_Master_Black.png"
              height="75px"
              style={{ marginBottom: '16px' }}
            />
          </a>
          <p
            style={{
              fontSize: '18px',
              fontWeight: '400',
            }}
          >
            It looks like this form doesn't exist any more. Make your own forms
            fast with{' '}
            <a href="https://paperform.co?utm_source=expiredform&utm_campaign=expiredform">
              Paperform
            </a>
          </p>
        </div>
      </DefaultLayout>
    );
  }
}
